import { render } from "./CustomPanel.vue?vue&type=template&id=7013b486&scoped=true&ts=true"
import script from "./CustomPanel.vue?vue&type=script&lang=ts"
export * from "./CustomPanel.vue?vue&type=script&lang=ts"

import "./CustomPanel.vue?vue&type=style&index=0&id=7013b486&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7013b486"]])

export default __exports__